<template>
	<el-card shadow="never" class="l-main-card">
		<div shadow="never">
			<div class="l-table-toolbar">
				<l-auth-button type="primary" auth="assets_dispose_add_btn" @click="add_visible = true"> 新建 </l-auth-button>
				<div class="l-simple-search-container">
					<el-input placeholder="请输入单号" v-model="search_data.order_no" class="input-with-select">
						<el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
					</el-input>
					<div class="l-show-more-search" @click="showSearch">
						<i-filter theme="outline" size="18" />
						<span>高级搜索</span>
					</div>
				</div>
			</div>
			<l-table :data="data" v-loading="loading" row-key="id">
				<el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>
				<el-table-column prop="order_no" label="单号" min-width="180" show-overflow-tooltip> </el-table-column>
				<el-table-column label="审批状态" min-width="80" show-overflow-tooltip>
					<template v-slot="{ row }">
						<l-approval-state :state="row.state"></l-approval-state>
					</template>
				</el-table-column>
				<el-table-column label="处置数量" min-width="80" prop="assets_count" show-overflow-tooltip> </el-table-column>
				<el-table-column label="处置类型" min-width="180" prop="type" show-overflow-tooltip>
					<template v-slot="{ row }">
						{{ getTypeName(row.type) }}
					</template>
				</el-table-column>
				<el-table-column label="处置日期" min-width="100" prop="dispose_date" show-overflow-tooltip> </el-table-column>
				<el-table-column label="处置金额" min-width="100" prop="money" show-overflow-tooltip> </el-table-column>
				<el-table-column label="备注" min-width="200" prop="remark" show-overflow-tooltip> </el-table-column>
				<el-table-column label="申请人" min-width="100" prop="create_user_name" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="create_time" label="申请时间" width="160"> </el-table-column>

				<el-table-column fixed="right" label="操作" width="240" align="center">
					<template slot-scope="{ row }">
						<l-auth-text-button type="primary" auth="assets_dispose_reapply_btn" :disabled="row.state != 3 && row.state != 4" @click="reapply(row.id)"><i-redo theme="outline" />重新申请</l-auth-text-button>
						<span class="l-action-separator">|</span>
						<l-auth-text-button type="primary" auth="assets_dispose_info_btn" @click="showInfo(row.id)"><i class="el-icon-info"></i>详情</l-auth-text-button>
						<span class="l-action-separator">|</span>
						<l-auth-text-button type="danger" auth="assets_dispose_withdraw_btn" :disabled="row.state != 1" @click="withdraw(row.id)"> <i-return theme="outline" />撤销 </l-auth-text-button>
					</template>
				</el-table-column>
			</l-table>

			<el-drawer title="高级搜索" class="l-search-drawer" v-loading="search_loading" :modal="false" :visible.sync="search_visible" size="400px" :append-to-body="false" :modal-append-to-body="false" z-indx="-1">
				<div class="l-search-drawer-body">
					<el-form label-width="80px" ref="search_form" :model="search_data">
						<el-form-item label="审批状态" prop="state">
							<el-select v-model="search_data.state" filterable placeholder="请选择审批状态" clearable>
								<el-option v-for="item in states" :key="item.value" :label="item.name" :value="item.value"> </el-option>
							</el-select>
						</el-form-item>
						<!-- 
						<el-form-item label="领用日期" prop="date_range">
							<l-el-date-range v-model="search_data.date_range"> </l-el-date-range>
						</el-form-item>

						<div class="l-cust-select">
							<el-form-item prop="dispose_org_id" label="领用组织">
								<el-select ref="s_dispose_org_id" v-model="search_data.dispose_org_id" placeholder="请选择领用组织" clearable @clear="curr_use_org_name = ''">
									<el-option :value="search_data.dispose_org_id" :label="curr_use_org_name" style="height: auto; padding: 0">
										<el-tree
											ref="dispose_org_id"
											:data="org_tree"
											default-expand-all
											:expand-on-click-node="false"
											node-key="id"
											highlight-current
											:props="defaultProps"
											@node-click="(data) => handleOrgSelect(data, 'dispose_org_id', 'curr_use_org_name')"
											:current-node-key="search_data.use_org_id"
										></el-tree>
									</el-option>
								</el-select>
							</el-form-item>
						</div> -->
						<el-form-item label="备注" prop="remark">
							<el-input placeholder="请输入备注" v-model="search_data.remark" class="input-with-select"> </el-input>
						</el-form-item>
					</el-form>
				</div>

				<div class="l-search-drawer-footer">
					<el-button type="normal" @click="onReset">重置</el-button>
					<el-button type="primary" @click="onSearch">搜索</el-button>
				</div>
			</el-drawer>

			<!--分页-->
			<l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

			<!--添加-->
			<l-dialog :visible.sync="add_visible" title="新建" width="1200px">
				<l-assets-dispose-edit @on-success="onAddSucess" :visible.sync="add_visible" />
			</l-dialog>

			<!--重新申请-->
			<l-dialog :visible.sync="reapply_visible" title="重新申请" width="1200px">
				<l-assets-dispose-edit :id="reapply_id" @on-success="onReapplySucess" :visible.sync="reapply_visible" />
			</l-dialog>

			<!--详情-->
			<l-dialog :visible.sync="info_visible" title="详情" width="1200px">
				<l-assets-dispose-info :id="info_id" :visible.sync="info_visible" />
			</l-dialog>
		</div>
	</el-card>
</template>

<script>
import Vue from "vue";
import Edit from "./Edit";
import Info from "./Info";
import States from "../approval/States.vue";
import { states } from "../approval/states.js";
import { getName } from "./types";
import { Return, Redo, Filter } from "@icon-park/vue";
export default {
	name: "l-assets-dispose-index",
	components: {
		[Edit.name]: Edit,
		[States.name]: States,
		"i-return": Return,
		"i-redo": Redo,
		"i-filter": Filter,
		[Info.name]: Info,
	},
	data() {
		return {
			data: [],
			count: 0,
			page: 1,
			page_size: Vue.$_config.page.page_size,
			loading: false,

			add_visible: false, //是否显示添加

			edit_visible: false, //是否显示编辑
			edit_id: 0,

			info_visible: false, //是否显示详情
			info_id: 0,

			reapply_visible: false, //是否显示重新申请
			reapply_id: 0,

			//搜索
			search_visible: false,
			search_loading: false,
			states: states,
			search_loaded: false,
			curr_use_org_name: "",
			org_tree: [],
			defaultProps: {
				children: "children",
				label: "name",
			},
			search_data: {
				order_no: "",
				state: "",
				dispose_org_id: "",
				date_range: [],
				remark: "",
			},
			rel_search_data: {},
			show_more_search: false,
		};
	},

	mounted() {
		this.getList();
	},

	methods: {
		//获取数据
		getList() {
			this.loading = true;
			this.$_invoke("assetsDispose_getList", {
				page: this.page,
				page_size: this.page_size,
				...this.rel_search_data,
			})
				.then((ret) => {
					this.data = ret.data;
					this.count = ret.count;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		//点击搜索按钮
		onSearch() {
			this.page = 1;
			this.rel_search_data = this.search_data;
			this.getList();
		},

		//获取搜索数据
		getSearchData() {
			if (this.search_loaded) return;
			this.$_invoke("assetsDispose_getSearchData", {}).then((ret) => {
				this.loading = false;
				this.search_loaded = true;
				this.org_tree = ret.org_tree;
			});
		},

		//获取类型名称
		getTypeName(type) {
			return getName(type);
		},

		//点击显示高级搜索
		showSearch() {
			this.search_visible = true;
			this.getSearchData();
		},

		//选择使用机构
		handleOrgSelect(data, form_filed, name_filed) {
			this.search_data[form_filed] = data.id;
			this[name_filed] = data.name;
			this.$refs[form_filed].setCurrentKey(data.id);
			this.$refs["s_" + form_filed].blur();
		},

		//点击重置搜索框
		onReset() {
			this.search_data.dispose_org_id = "";
			this.curr_use_org_name = "";
			this.$refs.search_form.resetFields();
			this.rel_search_data = {};
		},

		//添加成功回调
		onAddSucess() {
			this.add_visible = false;
			this.getList();
		},

		//显示修改界面
		showEdit(id) {
			this.edit_id = id;
			this.$nextTick(() => {
				this.edit_visible = true;
			});
		},

		//编辑成功回调
		onEditSuccess() {
			this.edit_visible = false;
			this.getList();
		},

		//显示详情
		showInfo(id) {
			this.info_id = id;
			this.$nextTick(() => {
				this.info_visible = true;
			});
		},

		//重新申请
		reapply(id) {
			this.reapply_id = id;
			this.$nextTick(() => {
				this.reapply_visible = true;
			});
		},

		//重新申请成功
		onReapplySucess() {
			this.reapply_visible = false;
			this.reapply_id = 0;
			this.getList();
		},

		//删除
		withdraw(id) {
			this.$confirm("确定撤销该申请吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$_invoke(`assetsDispose_withdraw`, { id }).then(() => {
						this.$_msg.success("撤销成功");
						this.getList();
					});
				})
				.catch(() => {});
		},
	},
};
</script>
